import BoardContainer from "../board/BoardContainer";

const categories = [
  { postType: 'PT04', title: '전체', sectionTitle: '프로그램' },
];

const Program = () => {
  return (
    <BoardContainer categories={categories} postType="PT040" />
  );
}

export default Program;